<template>
    <q-carousel
        v-model="selectedImageIndex"
        animated
        arrows
        navigation
        :height="height"
        control-color="primary"
    >
        <img
            v-for="(image, index) in images"
            :key="index"
            class="layout"
            :name="index + 1"
            :src="image"
        >
    </q-carousel>
</template>

<script setup>
import { ref } from 'vue'

defineProps({
    images: {
        type: Array,
        required: true,
    },
    height: {
        type: String,
        default: '100vh',
    },
})
const selectedImageIndex = ref(1)
</script>

<style scoped>
.layout{
    width: 100%;
    aspect-ratio: 1;
    object-fit: contain;
}
</style>
